import { API_ENDPOINT } from '../../Constants';

export const SET_SCHEDULER = "SET_SCHEDULER";
export const SET_SCHEDULED_LIST = "SET_SCHEDULED_LIST";
export const SET_SCHEDULED_LIST_DATERANGE = "SET_SCHEDULED_LIST_DATERANGE";
export const SET_RESET_SCHEDULE_LIST = "SET_RESET_SCHEDULE_LIST";
export const SET_LOADING_API = "SET_LOADING_API";

export const setScheduler = (payload: object) => {
    return {
        type: SET_SCHEDULER,
        payload: payload,
    };
}

export const setScheduledList = (payload: object) => {
    return {
        type: SET_SCHEDULED_LIST,
        payload: payload,
    };
}

export const setScheduledListDateRange = (payload: object) => {
    return {
        type: SET_SCHEDULED_LIST_DATERANGE,
        payload: payload,
    };
}

export const resetScheduledLst = () => {
    return {
        type: SET_RESET_SCHEDULE_LIST,
    };
}

export const setLoadingApi = (payload: any) => {
    return {
        type: SET_LOADING_API,
        payload: payload,
    };
}


export const getAllScheduledList = ({ startDate, endDate, history, token }: any) => async (
    dispatch: any
) => {
    var reqValues = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            authorization: `Bearer ${localStorage.getItem('id_token')}`
        }
    };
    const queryString = token ? `?limit=10&startDate=${startDate}&endDate=${endDate}&nextToken=${token ? token : ""}`
        : `?limit=10&startDate=${startDate}&endDate=${endDate}`;

    const api_url = `${API_ENDPOINT}/orgs/${localStorage.getItem('orgId')}/packages/schedule${queryString}`;
    if(!startDate || !endDate) return false
    dispatch(setLoadingApi(true));
    fetch(api_url, reqValues)
        .then((result) => {
            if (result.status === 403) {
                history.push({
                    pathname: "/",
                });
            } else {
                return result.json();
            }
        })
        .then((result) => {
            if (result.result) {
                dispatch(setScheduledList(result));
            }
            dispatch(setLoadingApi(false));
        })
        .catch((error) => {
            dispatch(setLoadingApi(false));
        });
}

export const getContent = ({ contentId, history }: any) => async (
    dispatch: any
) => {
    var reqValues = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            authorization: `Bearer ${localStorage.getItem('id_token')}`
        }
    };

    const api_url = `${API_ENDPOINT}/contents/${contentId}`;
    dispatch(setLoadingApi(true));
    fetch(api_url, reqValues)
        .then((result) => {
            if (result.status === 403) {
                history.push({
                    pathname: "/",
                });
            } else {
                return result.json();
            }
        })
        .then((result) => {
            if (result.result) {
                dispatch({ type: 'TEMP_CONTENT_DATA', data: result.result });
            }
            dispatch(setLoadingApi(false));
        })
        .catch((error) => {
            dispatch(setLoadingApi(false));
        });
}

export const fetchContentDetails = async({ contentId, history }: any) => {
    var reqValues = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            authorization: `Bearer ${localStorage.getItem('id_token')}`
        }
    };

    const api_url = `${API_ENDPOINT}/contents/${contentId}`;
    return fetch(api_url, reqValues)
        .then((result) => {
            if (result.status === 403) {
                history.push({
                    pathname: "/",
                });
            } else {
                return result.json();
            }
        })
        .then((result) => {
            if (result.result) {
                return result.result
            }
            return;
        })
        .catch((error) => {
            return
        });
}

export const getGroup = ({ groupId, history }: any) => async (
    dispatch: any
) => {
    var reqValues = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            authorization: `Bearer ${localStorage.getItem('id_token')}`
        }
    };

    const api_url = `${API_ENDPOINT}/orgs/${localStorage.getItem('orgId')}/groups/${groupId}`;
    dispatch(setLoadingApi(true));
    fetch(api_url, reqValues)
        .then((result) => {
            if (result.status === 403) {
                history.push({
                    pathname: "/",
                });
            } else {
                return result.json();
            }
        })
        .then((result) => {
            if (result.result) {
                dispatch({ type: 'TEMP_GROUP_DATA', data: result.result });
            }
            dispatch(setLoadingApi(false));
        })
        .catch((error) => {
            dispatch(setLoadingApi(false));
        });
}